
import Vue from "vue";
import axios from "axios";
import AppModal from "@components/AppModal.vue";
import { docReady, qsa, onClick } from "@libs/helpers";

docReady( () => {
	qsa('[data-basic-vue]', el => {
		const storeText = el.getAttribute('data-basic-vue');
		let store = {};
		if ( storeText ) {
			store = JSON.parse( storeText );
		}
		return new Vue({
			data: {
				store
			},
			el,
			template: el.innerHTML,
		});
	});
});